import React, { useState, useEffect } from "react";
import api from "../lib/api";
import { useParams, useNavigate } from "react-router-dom";
import "./EventCreate.css";

const PREDEFINED_LOCATIONS = [
  { label: "Zoom", value: "zoom" },
  { label: "その他", value: "other" },
];

const PREDEFINED_TARGETS = [
  "全社員",
  "部署単位",
  "課単位",
  "家族参加可能",
  "パート・アルバイト・契約社員",
];

const PREDEFINED_WEATHER = [
  { label: "晴れ", value: "晴れ" },
  { label: "曇り", value: "曇り" },
  { label: "雨", value: "雨" },
  { label: "雪", value: "雪" },
];

const PREDEFINED_RAIN_POLICIES = ["開催", "中止", "決行"];

const EventConfirmation = () => {
  const { eventId } = useParams();
  const navigate = useNavigate();

  const [allDeptData, setAllDeptData] = useState([]);
  const [mainDepts, setMainDepts] = useState([]);

  const [formData, setFormData] = useState({
    eventName: "",
    eventDescription: "",
    eventDate: "",
    eventEndDate: "",
    startTime: "",
    endTime: "",
    location: "",
    regDeadline: "",
    weather: "",
    hasAnketo: false,
  });

  const [targetGroup, setTargetGroup] = useState([]);
  const [rainPolicy, setRainPolicy] = useState([]);
  const [generalPolicy, setGeneralPolicy] = useState([]);
  const [locationType, setLocationType] = useState("other");
  const [selectedDept, setSelectedDept] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [currentUser, setCurrentUser] = useState({});
  const [isPasswordVerified, setIsPasswordVerified] = useState(false);
  const [confirmPassword, setConfirmPassword] = useState("");
  const isEditMode = !!eventId;
  const pageTitle = isEditMode ? "イベント確認" : "イベント作成";

  const formatDate = (isoDate) => (isoDate ? isoDate.split("T")[0] : "");
  const formatTime = (isoTime) => {
    if (!isoTime) return "";
    const timePart = isoTime.includes("T") ? isoTime.split("T")[1] : isoTime;
    return timePart.substring(0, 5);
  };

  useEffect(() => {
    const fetchEventData = async () => {
      if (!isEditMode) return;
      setLoading(true);
      try {
        const res = await api.get(`/events/${eventId}/`);
        const data = res.data;

        const parseArray = (val) => {
          if (Array.isArray(val)) return val;
          if (typeof val === "string") {
            try {
              return JSON.parse(val);
            } catch {
              return val.includes(",") ? val.split(",").map((v) => v.trim()) : [val];
            }
          }
          return [];
        };

        const PLATFORM_PFXS = ["Zoom: ", "Teams: ", "Google Meet: ", "Skype: ", "Slack: "];
        const locText = data.location || "";
        const isZoom = PLATFORM_PFXS.some(p => locText.startsWith(p));
        const locType = isZoom ? "online" : "other";
        setFormData({
          eventName: data.eventName || "",
          eventDescription: data.description || "",
          eventDate: formatDate(data.eventDate),
          eventEndDate: formatDate(data.endTime || data.eventDate),
          startTime: formatTime(data.startTime),
          endTime: formatTime(data.endTime),
          location: data.location || "",
          regDeadline: formatDate(data.regDeadline),
          weather: data.weather || "",
          hasAnketo: data.hasAnketo || false,
        });

        setTargetGroup(parseArray(data.targetGroup));
        setRainPolicy(parseArray(data.rainPolicy));
        setGeneralPolicy(parseArray(data.policy));
        /*
        const loc = data.location?.toLowerCase().includes("zoom")
          ? "zoom"
          : "other";
        setLocationType(loc);*/
        setLocationType(locType);
        if (isZoom) {
             setFormData(prev => ({ ...prev, weather: "" }));
             setRainPolicy([]);
        }
      } catch (err) {
        console.error("イベント情報の取得エラー:", err);
        setMessage("イベント情報の取得に失敗しました。");
      } finally {
        setLoading(false);
      }
    };

    const fetchCurrentUser = async () => {
        try {
            const res = await api.get("/admin/me/");
            setCurrentUser(res.data);
        } catch (err) {
            console.error("ユーザー情報取得エラー:", err);
        }
    };

    const fetchDepartments = async () => {
      try {
        const res = await api.get("/departments/");
        const data = res.data;
        setAllDeptData(data);
        setMainDepts(data.filter(d => d.departmentId && d.departmentId.endsWith("00")));
      } catch (err) {
        console.error("部署取得エラー:", err);
      }
    };

    fetchEventData();
    fetchCurrentUser();
    fetchDepartments();
  }, [eventId, isEditMode]);

  const handleRead = (e) => {
    const { id, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [id]: value,
    }));
  };

  const handleReduce = () => { 
    navigate(`/event/reduce/${eventId}`);
  }

 
  //const handleEventUpdate = async () => {
   const handleComfirm = async () => {
    setMessage("");
    setLoading(true);
    if (!formData.eventName.trim()) {
      setMessage("イベント名を入力してください。");
      setLoading(false);
      return;
    }
    if (!formData.eventDescription.trim()) {
      setMessage("明細を入力してください。");
      setLoading(false);
      return;
    }
    if (!formData.hasAnketo) {
      setMessage("アンケートの有無を選択してください。");
      setLoading(false);
      return;
    }
    if (formData.eventDate && formData.eventEndDate && formData.eventDate > formData.eventEndDate) {
      setMessage("終了日は開始日以降に設定してください。");
      setLoading(false);
      return;
    }

    try {
      const startDateTime = `${formData.eventDate}T${formData.startTime}:00+09:00`;
      const endDateTime = `${formData.eventEndDate || formData.eventDate}T${formData.endTime}:00+09:00`;

      const payload = {
        // ... (payload data) ...
        ...formData,
        policy: generalPolicy,
        targetGroup,
        rainPolicy: locationType === "zoom" ? [] : rainPolicy,
        weather: locationType === "zoom" ? "" : formData.weather,
        startTime: startDateTime,
        endTime: endDateTime,
      };

      let res;
      if (isEditMode) {   
        res = await api.put(`/events/${eventId}/`, payload);
        setMessage("イベントが正常に更新されました。");
      } else {
        const createPayload = { ...payload, confirmPassword: confirmPassword }; 
        res = await api.post("/events/", createPayload);
        setMessage("イベントが正常に作成されました。"); 
        navigate(`/admin/event/edit/${res.data.id}`); 
      }
    } catch (err) {
      console.error("更新エラー:", err);
      setMessage("イベントの更新に失敗しました。");
    } finally {
      setLoading(false);
      setIsPasswordVerified(false); 
      setConfirmPassword("");
    }
  }

  const handleLocationTypeChange = (e) => {
    const newType = e.target.value.toLowerCase();
    setLocationType(newType);
    if (newType === "zoom") {
      setFormData((prev) => ({ ...prev, location: "Zoom", weather: "" }));
      setRainPolicy([]);
    } else {
      if (formData.location === "Zoom") {
        setFormData((prev) => ({ ...prev, location: "" }));
      }
    }
  };

  const handleCheckboxChange = (option, setStateFunc) => {
    setStateFunc((prev) =>
      prev.includes(option)
        ? prev.filter((i) => i !== option)
        : [...prev, option]
    );
  };

  const handleDepartmentChange = (e) => {
    const dept = e.target.value;
    setSelectedDept(dept);
    if (dept && !targetGroup.includes(dept)) {
      setTargetGroup((prev) => [...prev, dept]);
      setSelectedDept("");
    }
  };

  const handleRemoveTarget = (dept) => {
    setTargetGroup((prev) => prev.filter((d) => d !== dept));
  };

  const handleBack = () => {
    navigate("/event/list");
  };

  if (loading && isEditMode && !formData.eventName) {
    return <div className="event-create-container loading-state">データを読み込み中...</div>;
  }

  return (
    <div className="event-create-page-container">
      <h1 className="form-title">{pageTitle}</h1>
    <button type="button" onClick={handleReduce} className="btn-back adm-btn">修正</button>
      <form className="event-create-form" onSubmit={handleRead}>
        {/* イベント名 */}
        <div className="form-row-group">
          <label className="form-label required" htmlFor="eventName">イベント名</label>
          <div className="form-field-wrapper">
            <div className="event-name-input-group">
              <input
                type="text"
                id="eventName"
                value={formData.eventName}
                onChange={handleRead}
                required
                readOnly
                className="input-text-long"
              />
              <span className="char-limit-text">(※20文字制限)</span>
            </div>
          </div>
        </div>
        {/* イベント明細 */}
        <div className="form-row-group">
          <label className="form-label required" htmlFor="eventDescription">イベント明細</label>
          <div className="form-field-wrapper">
            <textarea
              id="eventDescription"
              value={formData.eventDescription}
              onChange={handleRead}
              required
              readOnly
              className="input-text-long"
            />
          </div>
        </div>
        {/* 開催日 */}
        <div className="form-row-group">
          <label className="form-label required">開催日</label>
          <div className="form-field-wrapper date-range-wrapper">
            <div className="date-input-group">
              <label htmlFor="eventDate">開始日:</label>
              <input
                type="date"
                id="eventDate"
                value={formData.eventDate}
                onChange={handleRead}
                required
                readOnly
                className="input-date-single"
              />
            </div>
            <span className="date-separator">〜</span>
            <div className="date-input-group">
              <label htmlFor="eventEndDate">終了日:</label>
              <input
                type="date"
                id="eventEndDate"
                value={formData.eventEndDate}
                onChange={handleRead}
                readOnly
                className="input-date-single"
              />
            </div>
          </div>
        </div>

        {/* 開催時間 */}
        <div className="form-row-group">
          <label className="form-label required" htmlFor="startTime">開催時間</label>
          <div className="form-field-wrapper time-range-wrapper">
            <input
              type="time"
              id="startTime"
              value={formData.startTime}
              onChange={handleRead}
              required
              readOnly
              className="input-time"
            />
            <span className="time-separator">〜</span>
            <input
              type="time"
              id="endTime"
              value={formData.endTime}
              onChange={handleRead}
              required
              readOnly
              className="input-time"
            />
          </div>
        </div>

        {/* 開催場所 */}
        <div className="form-row-group">
          <label className="form-label required" htmlFor="locationType">開催場所</label>
          
          <div className="form-field-wrapper location-input-group">

            <div className="radio-group location-radio-group">
              {PREDEFINED_LOCATIONS.map((loc) => (
                  <label key={loc.value} className="radio-label">
                      <input
                          type="radio"
                          name="locationType"
                          value={loc.value}
                          checked={locationType === loc.value}
                          onChange={handleRead}
                          required
                      />
                      {loc.label}
                  </label>
              ))}
            </div>
            {locationType && (
            <input
                type="text"
                id="location"
                value={formData.location}
                onChange={handleRead}
                readOnly={locationType === "zoom"}  
                required={locationType === "other"}
                disabled={locationType === "zoom"}
                className={`input-text-long ${locationType === "zoom" ? "input-disabled" : ""}`}
                placeholder={
                    locationType === "zoom"
                        ? "Zoom "
                        : "開催場所を入力（リンク、住所など）"
                }
            />
            )}
          </div>
          
        </div>

        {/* 締切日 */}
        <div className="form-row-group">
          <label className="form-label required" htmlFor="regDeadline">締切日</label>
          <div className="form-field-wrapper">
            <input
              type="date"
              id="regDeadline"
              readOnly
              value={formData.regDeadline}
              onChange={handleRead}
              required
              className="input-date-single"
            />
          </div>
        </div>

        {/* 対象者 */}
        <div className="form-row-group">
          <label className="form-label required" htmlFor="targetGroup">対象者</label>
          <div className="form-field-wrapper target-group-selector">
            {/* チェックボックス一覧（読み取り専用） */}
            <div className="checkbox-group">
              {PREDEFINED_TARGETS.map((target) => (
                <label key={target} className="checkbox-label">
                  <input
                    type="checkbox"
                    readOnly
                    checked={targetGroup.filter(t => !t.startsWith("dept:") && !t.startsWith("sec:")).includes(target)}
                    onChange={() => {}}
                  />
                  {target}
                </label>
              ))}
            </div>

            {/* 部署単位が選択されている場合、選択した部署のみ表示 */}
            {targetGroup.includes("部署単位") && (() => {
              const selectedDeptNames = targetGroup
                .filter(t => t.startsWith("dept:"))
                .map(t => t.replace("dept:", ""));
              return (
                <div className="selected-group-display">
                  <span className="selected-group-label">選択部署：</span>
                  {selectedDeptNames.length > 0
                    ? selectedDeptNames.map((name) => (
                        <span key={name} className="target-tag readonly-tag">{name}</span>
                      ))
                    : <span className="selected-group-label">（部署未選択）</span>
                  }
                </div>
              );
            })()}

            {/* 課単位が選択されている場合、選択した課のみ表示 */}
            {targetGroup.includes("課単位") && (() => {
              const selectedSectionNames = targetGroup
                .filter(t => t.startsWith("sec:"))
                .map(t => t.replace("sec:", ""));
              return (
                <div className="selected-group-display">
                  <span className="selected-group-label">選択課：</span>
                  {selectedSectionNames.length > 0
                    ? selectedSectionNames.map((name) => (
                        <span key={name} className="target-tag readonly-tag">{name}</span>
                      ))
                    : <span className="selected-group-label">（課未選択）</span>
                  }
                </div>
              );
            })()}
          </div>
        </div>

        {/* 天気・雨天時規定 */}
        {locationType !== "zoom" && (
          <>
            {/* 天気 */}
            <div className="form-row-group">
              <label className="form-label" htmlFor="weather">天気</label>
              <div className="form-field-wrapper">
                <div className="radio-group weather-radio-group">
                  {PREDEFINED_WEATHER.map((item) => (
                    <label key={item.value} className="radio-label">
                      <input
                        type="radio"
                        name="weather"
                        value={item.value}
                        readOnly
                        checked={formData.weather === item.value}
                        onChange={handleRead}
                      />
                      {item.label}
                    </label>
                  ))}
                </div>
              </div>
            </div>

            {/* 雨天時・中止規定 */}
            <div className="form-row-group">
              <label className="form-label" htmlFor="rainPolicy">雨天時・中止規定</label>
              <div className="form-field-wrapper">
                <div className="checkbox-group">
                  {PREDEFINED_RAIN_POLICIES.map((policy) => (
                    <label key={policy} className="checkbox-label">
                      <input
                        type="checkbox"
                        readOnly
                        checked={rainPolicy.includes(policy)}
                        onChange={() => handleRead(policy, setRainPolicy)}
                      />
                      {policy}
                    </label>
                  ))}
                </div>
              </div>
            </div>
          </>
        )}

        {/*  作成者 ) */}
        <div className="form-row-group">
            <label className="form-label-wide" htmlFor="createdBy">作成者</label>
            <div className="form-field-wrapper">
                <input
                    type="text" value={currentUser.username || "ログイン中ユーザー"} disabled
                    className="input-text-long input-disabled"
                />
            </div>
        </div>

        <div className="form-row-group">
          <label className="form-label-wide" htmlFor="hasAnketo">アンケートの有無</label>
          <div className="form-field-wrapper">
            <div className="radio-group anketo-radio-group">
              <label className="radio-label">
                <input
                  type="radio"
                  name="hasAnketo"
                  value={true}
                  readOnly
                  checked={formData.hasAnketo === true}
                  onChange={handleRead}
                />
                アンケートあり
              </label>
              <label className="radio-label">
                <input
                  type="radio"
                  name="hasAnketo"
                  value={false}
                  readOnly
                  checked={formData.hasAnketo === false}
                  onChange={handleRead}
                />
                アンケートなし
              </label>
            </div>
          </div>
        </div>

        {/* ボタン */}
        <div className="button-group">
          <button type="button" onClick={handleBack} className="btn-back adm-btn">
            戻る
          </button>
        </div>
      </form>
    </div>
  );
};

export default EventConfirmation;